import Vue from 'vue'
import Vuex, {ActionContext} from 'vuex'
import storage from '@/lib/storage'
import registration from '@/store/modules/registration'
import clientTypes from '@/store/modules/clientTypes'
import configuration from '@/store/modules/configuration'
import profile from '@/store/modules/profile'
import termOfServices from '@/store/modules/termOfServices'


Vue.use(Vuex)

export class RootState {
  public userToken!: string
  public dialogState: DialogState[] = []
}


export class PopupState {
  public popup?: any | null
  public popupProps: any = null
  public popupTitle!: string | null
  public hideTopbar!: boolean

  constructor(popup: any | null, popupProps: any, popupTitle: string | null = null, hideTopbar: boolean = false) {
    this.popup = popup
    this.popupProps = popupProps
    this.popupTitle = popupTitle
    this.hideTopbar = hideTopbar
  }
}

export class DialogState extends PopupState {
  public emitConfirm: boolean = false

  public readonly defaultDialogConfirmedEvent: string = 'dialogConfirm'
  public dialogConfirmedEvent: string = 'dialogConfirm'

  constructor(
    // popup arguments
    popup: any | null, popupProps: any, popupTitle: string | null = null, hideTopbar: boolean = false,
    // dialogs events
    dialogConfirmedEvent?: string | null,
  ) {
    super(popup, popupProps, popupTitle, hideTopbar)

    if (typeof dialogConfirmedEvent === 'string') {
      this.dialogConfirmedEvent = dialogConfirmedEvent
    }
  }

  public isDefaultConfirm() {
    return this.dialogConfirmedEvent === this.defaultDialogConfirmedEvent
  }
}

export default new Vuex.Store({
  state: new RootState(),
  mutations: {
    INIT_ROOT_STATE(state, payload) {
      storage.restore('root', state)
    },
    UPDATE_USER_TOKEN(state, payload) {
      state.userToken = payload
    },
    OPEN_DIALOG(state, payload: DialogState) {
      // TODO: I would like a lot to check if the item is already present in the stack, but the comparison always
      // returns false
      if (state.dialogState.length === 0) {
        state.dialogState.push(payload)
      }
    },
    CLOSE_DIALOG(state, index?: number) {
      if (index) {
        state.dialogState.splice(index, 1)
      } else {
        state.dialogState.pop()
      }
    },
    FLUSH_EMPTY_QUEUE(state) {
      if (state.dialogState.length) {
        for (let i = state.dialogState.length - 1; i >= 0; --i) {
          if (state.dialogState[i] && !state.dialogState[i].popup) {
            state.dialogState.splice(i, 1)
          }
        }
      }
    },
    FLUSH_DIALOG_QUEUE(state) {
      state.dialogState = []
    },
  },
  actions: {
    init(store: ActionContext<RootState, any>, payload) {
      store.commit('INIT_ROOT_STATE')
    },
    sleep(store: ActionContext<RootState, any>, payload) {
      storage.save('root', store.state)
    },
    purge(store: ActionContext<RootState, any>, payload) {
      storage.delete('root')
    },
    updateUserToken(store: ActionContext<RootState, any>, payload) {
      store.commit('UPDATE_USER_TOKEN', payload)
      store.dispatch('sleep')
    },
    openDialog(store: ActionContext<RootState, any>, payload) {
      store.commit('OPEN_DIALOG', payload)
    },
    closeDialogNoEvents(store: ActionContext<RootState, any>, index?: number) {
      store.commit('CLOSE_DIALOG', index)
    },
    closeDialog(store: ActionContext<RootState, any>, index?: number) {
      store.commit('CLOSE_DIALOG', index)
    },
    confirmDialog(store: ActionContext<RootState, any>, index?: number) {
      const dialogState = store.state.dialogState
      store.commit('CLOSE_DIALOG')
    },
    flushEmptyPopups(store: ActionContext<RootState, any>) {
      store.commit('FLUSH_EMPTY_QUEUE')
    },
    closeOverlays(store: ActionContext<RootState, any>) {
      store.commit('FLUSH_DIALOG_QUEUE')
    },
  },
  modules: {
    termOfServices,
    configuration,
    registration,
    clientTypes,
    profile,
  },
})
